import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import { Container, Row, Col } from 'reactstrap';
import Header from '../../layout/Header/Header';
import GlobalBotControl from './GlobalBotControl';
import UserOrdersControl from './UserOrdersControl';
import { showError } from '../../../utils/sweetAlertHelper';

function AdminPanel() {
  const navigate = useNavigate();
  const { user, isAuth } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(true);

  // Wait for AuthContext to load
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  // Check admin permissions after loading
  useEffect(() => {
    if (!isLoading && isAuth) {
      const isAdmin = user?.menu_admin === true;
      
      if (!isAdmin) {
        showError('Se requieren permisos de administrador.', 'Acceso Denegado');
        navigate('/');
      }
    } else if (!isLoading && !isAuth) {
      showError('Debes iniciar sesión primero.', 'Autenticación Requerida');
      navigate('/login');
    }
  }, [isLoading, isAuth, user, navigate]);

  // Show loading while checking auth
  if (isLoading) {
    return (
      <>
        <Header />
        <Container className="mt-4">
          <p className="text-center">Cargando...</p>
        </Container>
      </>
    );
  }

  // Check if user is admin
  if (!isAuth || !user?.menu_admin) {
    return null;
  }

  return (
    <>
      <Header />
      <br />
      <br />
      <Container className="col-sm-11">
        <Row>
          <Col md={12}>
            <h3 className="text-center">Panel de Administración</h3>
            <h6 className="text-center text-muted mb-4">Control global del sistema y gestión de órdenes</h6>
          </Col>
        </Row>
        
        <Row>
          <Col md={12}>
            <GlobalBotControl />
          </Col>
        </Row>
        
        <br />
        
        <Row>
          <Col md={12}>
            <UserOrdersControl />
          </Col>
        </Row>
      </Container>
      <br />
    </>
  );
}

export default AdminPanel;